/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Lock Light',
  definitions: {
    '16': {
      viewBox: '0 0 16 16',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.45 6.77461V4.50188C4.45 2.64374 6.08989 1.22461 8 1.22461C9.91011 1.22461 11.55 2.64374 11.55 4.50188V6.77461H12C12.5523 6.77461 13 7.22232 13 7.77461V13.7746C13 14.3269 12.5523 14.7746 12 14.7746H4C3.44772 14.7746 3 14.3269 3 13.7746V7.77461C3 7.22232 3.44772 6.77461 4 6.77461H4.45ZM5.55 4.50188C5.55 3.34756 6.5964 2.32461 8 2.32461C9.4036 2.32461 10.45 3.34756 10.45 4.50188V6.77461H5.55V4.50188ZM4.1 13.6746V7.87461H11.9V13.6746H4.1Z"
            fill="currentColor"
          />
        </>
      ),
    },
    '32': {
      viewBox: '0 0 32 32',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.45 14.7746V12.5019C12.45 10.6437 14.0899 9.22461 16 9.22461C17.9101 9.22461 19.55 10.6437 19.55 12.5019V14.7746H20C20.5523 14.7746 21 15.2223 21 15.7746V21.7746C21 22.3269 20.5523 22.7746 20 22.7746H12C11.4477 22.7746 11 22.3269 11 21.7746V15.7746C11 15.2223 11.4477 14.7746 12 14.7746H12.45ZM13.55 12.5019C13.55 11.3476 14.5964 10.3246 16 10.3246C17.4036 10.3246 18.45 11.3476 18.45 12.5019V14.7746H13.55V12.5019ZM12.1 21.6746V15.8746H19.9V21.6746H12.1Z"
            fill="currentColor"
          />
        </>
      ),
    },
    '48': {
      viewBox: '0 0 48 48',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.9332 14.7637L12.9332 20.5338H11C9.89543 20.5338 9 21.4293 9 22.5338V42.218C9 43.3226 9.89543 44.218 11 44.218H37C38.1046 44.218 39 43.3226 39 42.218V22.5338C39 21.4292 38.1046 20.5338 37 20.5338H35.0668L35.0668 14.7637C35.0668 11.3668 33.8365 8.60872 31.8119 6.7023C29.7928 4.80097 27.023 3.7832 24 3.7832C20.977 3.7832 18.2072 4.80097 16.188 6.7023C14.1635 8.60872 12.9332 11.3668 12.9332 14.7637ZM17.045 7.61234C15.2903 9.26458 14.1832 11.6843 14.1832 14.7637L14.1832 20.5338H17.3254L17.3254 14.7869C17.3254 12.7521 18.0641 11.083 19.2939 9.92504C20.5182 8.77215 22.19 8.16232 24.0001 8.16232C25.8101 8.16232 27.4819 8.77215 28.7063 9.92504C29.936 11.083 30.6747 12.7521 30.6747 14.7869L30.6746 20.5338H33.8168L33.8168 14.7637C33.8168 11.6843 32.7097 9.26458 30.955 7.61234C29.195 5.955 26.7439 5.0332 24 5.0332C21.2561 5.0332 18.805 5.955 17.045 7.61234ZM29.4246 20.5338L29.4247 14.7869C29.4247 13.0696 28.8091 11.7389 27.8493 10.8351C26.8841 9.92619 25.5311 9.41232 24.0001 9.41232C22.469 9.41232 21.116 9.92619 20.1508 10.8351C19.191 11.7389 18.5754 13.0696 18.5754 14.787L18.5754 20.5338H29.4246ZM37 21.7838H11C10.5858 21.7838 10.25 22.1196 10.25 22.5338V42.218C10.25 42.6322 10.5858 42.968 11 42.968H37C37.4142 42.968 37.75 42.6322 37.75 42.218V22.5338C37.75 22.1196 37.4142 21.7838 37 21.7838Z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
